module.exports = __webpack_public_path__ + "img/9791185051314.d62d217d.jpg";